import { useStorage } from "@vueuse/core";

/**
 * Composable for managing user's chat input preference (text vs voice)
 * Handles localStorage persistence with proper boolean serialization
 *
 * @returns {Ref<boolean|null>} Reactive reference to user's preference
 *   - true: User prefers text input
 *   - false: User prefers voice input
 *   - null: No preference stored (first time user)
 */
export function useChatInputPreference() {
    return useStorage("userChatInputPreference", null, undefined, {
        serializer: {
            read: (value) => {
                if (value === null || value === undefined) {
                    return null;
                }
                if (value === "true") {
                    return true;
                }
                if (value === "false") {
                    return false;
                }
                return Boolean(value);
            },
            write: (value) => String(value),
        },
    });
}
